import createAction from 'redux-actions/es/createAction';

export const showLocationRequest = createAction('SHOW_LOCATION_REQUEST');
